import { render } from "./WhySogdoItsCreativeComp.vue?vue&type=template&id=6b04e7e3&scoped=true"
import script from "./WhySogdoItsCreativeComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsCreativeComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsCreativeComp.vue?vue&type=style&index=0&id=6b04e7e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b04e7e3"]])

export default __exports__